import React, {useEffect, useRef, useState} from 'react'
import {fetchBlogs} from "../../../util/blog_api_utils";
import {BlogPost} from "../BlogPost";
import Slider from "react-slick";
import {Link} from "react-router-dom";
import leftIcon from '../../../../../assets/images/blog/left.png'
import rightIcon from '../../../../../assets/images/blog/right.png'

export const BlogPosts = ({ title = 'Popular Posts', description = 'Tips, Guides, Industry Best Practices, and News.', previewPosts = [] }) => {
  const [blogs, setBlogs] = useState([])
  const slider = useRef(null)

  useEffect(() => {
    fetchBlogs(null, true).then(blogs => {
      setBlogs(Array.isArray(blogs) ? blogs : []);
    }).catch(() => {});
  }, []);

  const onClickPrev = (e) => {
    e.preventDefault()
    slider.current?.slickPrev()
  }

  const onClickNext = (e) => {
    e.preventDefault()
    slider.current?.slickNext()
  }

  const usingPreview = !blogs.length && previewPosts.length > 0;
  const displayedBlogs = usingPreview ? previewPosts : blogs;
  const slides = displayedBlogs.map(blog => <BlogPost blogPost={blog} key={`blog-post-${blog.id}`}/>)

  return <div className="popular-posts-wrapper">
    <div className="popular-posts-wrapper-inner">
      <div className="popular-posts-subtitle">Latest posts</div>
      <div className="popular-posts-title">{title}</div>
      <div className="popular-posts-description-and-button">
        <div className="popular-posts-description">{description}</div>
        <Link className="projectEditButton popular-posts-view-all" to="/blog">View all posts</Link>
      </div>
    </div>


    <div className="popular-posts-cards-wrapper-inner">
      {displayedBlogs.length > 0 && <Slider
        slidesToShow={4}
        slidesToScroll={1}
        ref={slider}
        dots={false}
        arrows={false}
        centerMode={false}
        focusOnSelect={false}
        infinite={true}
        variableWidth={true}
        autoplay={false}
        draggable={false}
        responsive={[
          {
            breakpoint: 1680,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]}>
        {slides}
      </Slider>}
    </div>

    <div className="popular-posts-wrapper-inner">
      <div className="popular-posts-navigation">
        <a href="#" onClick={onClickPrev}><img src={leftIcon} /></a>
        <a href="#" onClick={onClickNext}><img src={rightIcon} /></a>
      </div>
    </div>
  </div>
}
